import { useMutation } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'

export interface CreatePlusPromotionCodeResult {
  createPlusPromotionCodeV2:
    | {
        __typename: 'PlusPromotionCodeV2'
        id: string
        code: string
        percentOff: number
        active: boolean
        maxRedemptions: number | null
        expiresAt: number | null
        createdAt: number
      }
    | {
        __typename: 'PlusPromotionCodeErrorV2'
        type: string
        error: string
      }
}

export interface CreatePlusPromotionCodeVariables {
  input: {
    code: string
    percentOff: number
    maxRedemptions?: number | null
    expiresAt?: number | null
  }
}

const MUTATION = gql`
  mutation CreatePlusPromotionCode($input: CreatePlusPromotionCodeInputV2!) {
    createPlusPromotionCodeV2(input: $input) {
      ... on PlusPromotionCodeV2 {
        id
        code
        percentOff
        active
        maxRedemptions
        expiresAt
        createdAt
      }
      ... on PlusPromotionCodeErrorV2 {
        type
        error
      }
    }
  }
`

export const useCreatePromotionCode = () => {
  return useMutation<CreatePlusPromotionCodeResult, CreatePlusPromotionCodeVariables>(MUTATION)
}
